import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {LinkRef, Product} from '@kion/data-models';
// tslint:disable-next-line:nx-enforce-module-boundaries
import {IconData} from '../../../../../../shared/ui/src/lib/shared/elements/icon-bar/icon-bar.component';
import {ProductPriceService} from '../../services/product-price.service';
import {Observable, of} from 'rxjs';
import {ResizeObserver} from '@juggle/resize-observer';
// tslint:disable-next-line:nx-enforce-module-boundaries
import {ProductUrlService} from '../../../../../cms/src/lib/services/product-url.service';

@Component({
    selector: 'kion-product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent implements OnInit, OnDestroy, AfterViewInit {

    @Input() product: Product;
    @Input() forceNetto: boolean;
    scale: string;

    icons$: Observable<IconData[]>;
    observer$ = new ResizeObserver(entries => {
        entries.forEach(entry => this.resizedCallback(entry.contentRect.width));
    });

    @ViewChild('card') card: ElementRef;

    constructor(private productPriceService: ProductPriceService, private productUrlService: ProductUrlService) {
    }

    get price(): { price: string, strikedPrice: string, isRanged: boolean } {
        let price = this.product.price;
        if (price) {
            if (this.forceNetto) {
                price = {
                    ...price,
                    netto: true
                }
            }
            return {
                price: this.productPriceService.getNettoPrice(price),
                strikedPrice: this.productPriceService.getStrikedNettoPrice(price),
                isRanged: this.product.price.priceType === 'FROM'
            }
        }
        return null;
    }

    get productLink(): LinkRef {
        return this.productUrlService.generateUrlFromProduct(this.product);
    }

    ngOnInit(): void {
        if (this.product) {
            const features = this.product.classifications?.find((classify) => classify.code === 'technicalDetails');
            this.icons$ = of(features?.features.map(feature => {
                if (feature) {
                    const code = feature.code.split('/1.0/technicalDetails.')[1];
                    return {
                        icon: './assets/icons/' + code + '_product_icon.svg',
                        description: feature.formattedFeatureValue,
                        alt: code + '_icon',
                        title: code + '_icon',
                    };
                }
            }));
        }
    }

    ngAfterViewInit(): void {
        if (this.card?.nativeElement) {
            this.observer$.observe(this.card.nativeElement);
        }
    }

    ngOnDestroy(): void {
        this.observer$.unobserve(this.card.nativeElement);
    }

    resizedCallback(width) {
        this.scale = 'large';
        if (width <= 300) {
            this.scale = 'medium';
        }
        if (width <= 215) {
            this.scale = 'small';
        }
    }
}
